export const sizeToStyles = {
  fontSize: {
    xs: 'var(--font-size-12)',
    sm: 'var(--font-size-14)',
    md: 'var(--font-size-16)',
    lg: 'var(--font-size-20)',
    xl: 'var(--font-size-24)',
  },
  lineHeight: {
    xs: 'var(--line-height-16)',
    sm: 'var(--line-height-20)',
    md: 'var(--line-height-24)',
    lg: 'var(--line-height-28)',
    xl: 'var(--line-height-32)',
  },
  letterSpacing: {
    xs: '0.03em',
    sm: '0.03em',
    md: '0.025em',
    lg: '0.025em',
    xl: '0.025em',
  },
} as const;

export const DEFAULT_ELEMENT_TYPE = 'p';
